module.exports = __webpack_public_path__ + "static/media/Template_63.2351392d.png";